import {
    MessageType,
    MessageOrigin,
    ChatMessageFieldsFragment,
} from '~graphql/generated/graphql'
import { format } from 'date-fns'
import { getClientFullName } from '~utils/helpers'

export function getCopyMessageText(message: ChatMessageFieldsFragment) {
    const messageSendTime = format(
        message.created_at,
        "MMM d, yyyy 'at' h:mm a",
    )
        .replace('AM', 'am')
        .replace('PM', 'pm')

    return `${getMessageUserName(message)} - ${messageSendTime}${'\n'}${message.text}`
}

/** System/automated messages (as opposed to manual client/clinic messages). */
export function isSystemMessage(message: ChatMessageFieldsFragment) {
    return (
        message.message_type === MessageType.System ||
        message.message_origin === MessageOrigin.System
    )
}

function getMessageUserName(message: ChatMessageFieldsFragment) {
    if (isSystemMessage(message)) {
        return 'System'
    }

    if (message.clinic_user) {
        return getClientFullName(message.clinic_user)
    }

    if (message.client) {
        return getClientFullName(message.client, true)
    }

    return 'No User'
}
